import { Page } from '../models/Elements';
import { NotificationTrapPlotDisease } from '../models/Entities';
import dateService from '../services/DateService';
import { coreApiAxios } from './CustomAxios';

class NotificationTrapPlotDiseaseApi {
    list = async (page: number, size: number, sortField: string, sortOrder: boolean, plotId?: number): Promise<Page<NotificationTrapPlotDisease>> => {
        const response = await coreApiAxios.get<Page<NotificationTrapPlotDisease>>(`/notification-trap-plot-diseases`, {
            params: { page, size, sortField, sortOrder, plotId }
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((notificationTrapPlotDisease) => this.loadDates(notificationTrapPlotDisease));

        return response.data;
    };

    /**
     * Loads the dates of a notification user.
     * @param notificationUser - the notification user
     */
    private loadDates(notificationTrapPlotDisease: NotificationTrapPlotDisease) {
        notificationTrapPlotDisease.notification.audit!.created = dateService.transformDate(notificationTrapPlotDisease.notification.audit!.created)!;
        notificationTrapPlotDisease.notification.audit!.updated = dateService.transformDate(notificationTrapPlotDisease.notification.audit!.updated)!;
    }
}

const notificationTrapPlotDiseaseApi: NotificationTrapPlotDiseaseApi = new NotificationTrapPlotDiseaseApi();
export default notificationTrapPlotDiseaseApi;
